import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { title: "Zone" }, {
    default: _withCtx(() => [
      _createVNode(_component_DataTable, {
        loading: _ctx.loading === 'loading',
        data: _ctx.items.data,
        columns: _ctx.fields,
        pagination: _ctx.items,
        onEdit: _ctx.editRecord,
        onDestroy: _ctx.deleteRecord,
        onCreate: _ctx.createRecord,
        onFilter: _ctx.filterRecord
      }, null, 8, ["loading", "data", "columns", "pagination", "onEdit", "onDestroy", "onCreate", "onFilter"]),
      _createVNode(_component_Form, {
        title: "Zone",
        visible: _ctx.visible,
        onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible = false)),
        onSave: _ctx.handleSaving,
        data: _ctx.form
      }, null, 8, ["visible", "onSave", "data"])
    ]),
    _: 1
  }))
}